export default () => (__ENV__ === 'local' || __ENV__ === 'development') && location.pathname.includes('/sandbox');
